<template>
    <BaseForm>
        <template #fields>
            <MultiLinkGroup>
                <MultiLink
                    :label="$t('favored-parallels-internal')"
                    :links="values.favoredParallelsInternal"
                    :error-messages="errors.favoredParallelsInternal"
                    @input="setFieldValue('favoredParallelsInternal', $event)"
                    @delete="setFieldValue('favoredParallelsInternal', $event)"
                />
                <MultiLink
                    :label="$t('favored-parallels-external')"
                    :links="values.favoredParallelsExternal"
                    :error-messages="errors.favoredParallelsExternal"
                    @input="setFieldValue('favoredParallelsExternal', $event)"
                    @delete="setFieldValue('favoredParallelsExternal', $event)"
                />
            </MultiLinkGroup>
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import MultiLinkGroup from '@/components/MultiLink/MultiLinkGroup.vue';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventSeriesParallelsSchema } from '../schemas';

const { series, createEventSeriesMultiLink } = useEventSeriesInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventSeriesMultiLink);

const favoredParallelsInternalId = computed(() => series.value?.favoredParallelsInternal?.id);
const favoredParallelsExternalId = computed(() => series.value?.favoredParallelsExternal?.id);

const favoredParallelsInternalLinks = computed(() => series.value?.favoredParallelsInternal?.links.nodes ?? []);
const favoredParallelsExternalLinks = computed(() => series.value?.favoredParallelsExternal?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventSeriesParallelsSchema,
    computed(() => ({
        favoredParallelsInternal: getFormFieldLinks(favoredParallelsInternalLinks),
        favoredParallelsExternal: getFormFieldLinks(favoredParallelsExternalLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            {
                id: favoredParallelsInternalId.value,
                fieldName: 'favoredParallelsInternal',
                links: values.value.favoredParallelsInternal,
            },
            {
                id: favoredParallelsExternalId.value,
                fieldName: 'favoredParallelsExternal',
                links: values.value.favoredParallelsExternal,
            },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
